import React, { ComponentType, ReactNode } from 'react';
import { BlockContentContext } from './BlockContent.utils';
import { ArticleBlockContentGridCol } from './types/components/ArticleBlockContentGridCol/ArticleBlockContentGridCol';

// Anything that varies beyond the article wrapper stays hand-written. An option per special case
// puts the boilerplate back with more indirection.

export type SerializerProps<Value> = { value: Value };

type Wrapper = ComponentType<{ className?: string; children?: ReactNode }>;

interface WrapperOptions {
  wrapper?: Wrapper;
  /** Article stylesheets hook onto these, so they are load-bearing. */
  className?: string;
}

export const createContextualSerializer =
  <Value,>(
    Block: ComponentType<SerializerProps<Value>>,
    { wrapper: ArticleWrapper = ArticleBlockContentGridCol, className }: WrapperOptions = {},
  ) =>
  (context: BlockContentContext = BlockContentContext.Stripped) => {
    if (context === BlockContentContext.Article) {
      return ({ value }: SerializerProps<Value>) => (
        <ArticleWrapper className={className}>
          <Block value={value} />
        </ArticleWrapper>
      );
    }
    return ({ value }: SerializerProps<Value>) => <Block value={value} />;
  };

export const createStandaloneSerializer =
  (Block: ComponentType, { wrapper: ArticleWrapper = ArticleBlockContentGridCol, className }: WrapperOptions = {}) =>
  (context: BlockContentContext = BlockContentContext.Stripped) => {
    if (context === BlockContentContext.Article) {
      return () => (
        <ArticleWrapper className={className}>
          <Block />
        </ArticleWrapper>
      );
    }
    return () => <Block />;
  };
